<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useChatStore} from "../../../store/chat"
import {useModalStore} from "../../../store/modal"
import {computed, ref} from "vue";
import {useRouter} from "vue-router";

const options = [
    {value: 'pending_order_chat_start', label: 'Generic chat start'},
    {value: 'reseller_schoolss_welcom', label: 'School chat start'},
]

const loading = ref(false)
const store = useChatStore()
const modalStore = useModalStore()
const router = useRouter()
const is_created = ref(false)

const external_id = ref('')
const profile_name = ref('')
const template = ref(null)

const can_submit = computed(() => external_id.value && profile_name.value && template.value && !loading.value)

const description = computed(() =>
    is_created.value
        ? "Chat has been created and the template message has been sent."
        : "If the number is not on WhatsApp, the first message will fail. You can resend it once the contact is reachable."
)

const createChat = async () => {
    loading.value = true
    await store.createManualChat(external_id.value, profile_name.value, template.value)
    loading.value = false
    is_created.value = true

    await router.push(`/chats/view/${store.chat?.id}`)
}
</script>

<template>
    <DefaultModalBase :description :heading="is_created ? 'Chat Created' : 'Start New Chat'"
                      :icon="is_created ? 'check-all' : 'call-default'" :loading :refresh="is_created">

        <div class="chat-assign-container">
            <brand-button variant="secondary" v-if="is_created" @click="modalStore.close(true)">Done</brand-button>

            <template v-if="!is_created">
                <brand-form-input label="WhatsApp number." placeholder="e.g. 27821234567" v-model="external_id"/>
                <brand-form-input label="Contact name." placeholder="e.g. John Smith" v-model="profile_name"/>
                <brand-form-select label="Chat start template." :options="options" v-model="template"/>
                <brand-button @click="createChat()" :disabled="!can_submit">Start Chat</brand-button>
            </template>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.chat-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
